import { createSelector } from 'reselect';
import RepatriationsTransactionsHistoryColumns from '../../containers/RepatriationsTransactionsHistoryColumns';
import TableDefinitions from '../../../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.REPATRIATIONS_TRANSACTIONS_HISTORY.isLoading;
export const getData = TableDefinitions.REPATRIATIONS_TRANSACTIONS_HISTORY.getDataFunction();
export const getColumns = createSelector(getData, RepatriationsTransactionsHistoryColumns);
